import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M4 14C4 11.0545 6.66667 7.05448 12 2C17.3333 7.05448 20 11.0545 20 14C20 18.3349 16.5522 21.8645 12.2492 21.9962L12 22C7.58172 22 4 18.4183 4 14ZM12 4.793L11.7832 5.01194C7.89798 8.95775 6 12.0287 6 14C6 17.3137 8.68629 20 12 20V4.793Z" />,
  'InvertColor'
);
